export { default as FundsDetailHeader } from "./FundsDetailHeader";
export type {
  FundsHeaderProps,
  FundsHeaderBaseProps,
} from "./FundsDetailHeader";
